import {get, getDelete} from '../../index.js'
import base from '../../base.js'

export const getCallRecordList = (params) => get(base.callRecordList, params)
export const deleteMemorandum = (id) => getDelete(`${base.memorandumDelete}/${id}`)
